module.exports = __webpack_public_path__ + "1345d2b5b77e0e78.svg";